// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__txciA","boxTitle":"Qualiphy_boxTitle__lPtk_","box":"Qualiphy_box__2Fh4e","toggleWrap":"Qualiphy_toggleWrap__1VOAy"};